<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="SelectBackground">
		<div class="SelectGrid">
			<label>Start Date</label>
			<p-calendar
				[disabled]="IsLoading() == true"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="StartDate"
				(ngModelChange)="onStartDateChange($event)"
				name="StartDate"
			></p-calendar>

			<label style="margin-left: 10px">End Date</label>
			<p-calendar
				[disabled]="IsLoading() == true"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="EndDate"
				(ngModelChange)="onEndDateChange($event)"
				name="EndDate"
			></p-calendar>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onView()">View Image</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPrint()">Print</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstDriverVerifyLog"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedDriverVerifyLog"
		dataKey="DriverVerifyLogID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th class="IMGCol">
					<p-columnFilter field="HasImageDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHasImageDesc
								[ngModel]="value"
								[options]="lstHasImageDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--LicenseNbr-->
				<th>
					<p-columnFilter type="text" field="LicenseNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--State-->
				<th>
					<p-columnFilter field="State" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterState
								[ngModel]="value"
								[options]="lstState"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--DOB-->
				<th>
					<!-- <p-columnFilter type="text" field="DOB" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--IssueDate-->
				<th>
					<!-- <p-columnFilter type="text" field="IssueDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ExpireDate-->
				<th>
					<!-- <p-columnFilter type="text" field="ExpireDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
					<p-columnFilter field="IsExpiredDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsExpiredDesc
								[ngModel]="value"
								[options]="lstIsExpiredDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--c_date-->
				<th>
					<!-- <p-columnFilter type="text" field="c_date" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--CAASSPersonName-->
				<th>
					<p-columnFilter field="CAASSPersonName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCAASSPersonName
								[ngModel]="value"
								[options]="lstCAASSPersonName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th class="IMGCol" pSortableColumn="HasImage">License Plate Image<p-sortIcon field="HasImage"></p-sortIcon></th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="LicenseNbr">License<p-sortIcon field="LicenseNbr"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="State">State<p-sortIcon field="State"></p-sortIcon></th>
				<th pSortableColumn="DOB">DOB<p-sortIcon field="DOB"></p-sortIcon></th>
				<th pSortableColumn="IssueDate">Issued<p-sortIcon field="IssueDate"></p-sortIcon></th>
				<th pSortableColumn="ExpireDate">Expires<p-sortIcon field="ExpireDate"></p-sortIcon></th>
				<th pSortableColumn="c_date">Scan Date<p-sortIcon field="c_date"></p-sortIcon></th>
				<th pSortableColumn="CAASSPersonName">CAASS User<p-sortIcon field="CAASSPersonName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-DriverVerifyLog>
			<tr [pSelectableRow]="DriverVerifyLog" (dblclick)="onRowDblClick(DriverVerifyLog)">
				<td class="IMGCol">
					<div>
						<img class="IMGClass" [src]="DriverVerifyLog.PlateImage" />
					</div>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ DriverVerifyLog[col.field] }}
				</td>

				<td style="font-weight: bold" [style.color]="DriverVerifyLog.IsExpired == 1 ? 'Red' : 'Black'">
					{{ DriverVerifyLog["ExpireDateDesc"] }}
				</td>

				<td *ngFor="let col of cols2" style="font-weight: bold">
					{{ DriverVerifyLog[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
